import { graphql, requestSubscription } from 'react-relay'

import { store } from '@src/store'
import { depositUpdated, Wallet, WalletConstant, withdrawUpdated } from './wallet.reducer'
import { walletDepositAddedSubscription } from './__generated__/walletDepositAddedSubscription.graphql'
import { walletDepositChangedSubscription } from './__generated__/walletDepositChangedSubscription.graphql'
import { walletWithdrawAddedSubscription } from './__generated__/walletWithdrawAddedSubscription.graphql'
import { walletWithdrawChangedSubscription } from './__generated__/walletWithdrawChangedSubscription.graphql'
import { walletWalletChangedSubscription } from './__generated__/walletWalletChangedSubscription.graphql'
import Env from '../RelayEnvironment'

export const getWallet = (shortName: string): Wallet | undefined => {
  const allWallets = store.getState().wallet.wallets
  return allWallets.find((x) => x.currency.toLowerCase() === shortName.toLowerCase() && !x.virtual)
}

export const getBalance = (currency: string, virtualId: number) => {
  const allWallets = store.getState().wallet.wallets
  if (!virtualId) {
    virtualId = 0
  }

  const wallet = allWallets.find(
    (x) => x.currency.toLowerCase() === currency.toLowerCase() && x.virtualId === virtualId
  )
  if (!wallet) {
    return 0
  }
  return wallet.balance
}

export const initWalletHelper = () => {
  requestSubscription<walletWalletChangedSubscription>(Env, {
    subscription: walletChangedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.walletChanged) {
        store.dispatch({
          type: WalletConstant.BALANCE_CHANGED,
          wallet: data.walletChanged,
        })
      }
    },
  })
  requestSubscription<walletDepositAddedSubscription>(Env, {
    subscription: depositAddedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.depositAdded) {
        depositUpdated.next(data.depositAdded)
      }
    },
  })

  requestSubscription<walletDepositChangedSubscription>(Env, {
    subscription: depositChangedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.depositChanged) {
        depositUpdated.next(data.depositChanged)
      }
    },
  })

  requestSubscription<walletWithdrawAddedSubscription>(Env, {
    subscription: withdrawAddedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.withdrawAdded) {
        withdrawUpdated.next(data.withdrawAdded)
      }
    },
  })

  requestSubscription<walletWithdrawChangedSubscription>(Env, {
    subscription: withdrawChangedSubscription,
    variables: {},
    onNext: (data) => {
      if (data?.withdrawChanged) {
        withdrawUpdated.next(data.withdrawChanged)
      }
    },
  })
}

const walletChangedSubscription = graphql`
  subscription walletWalletChangedSubscription {
    walletChanged {
      balance
      currency
      virtual
      virtualId
      insertedAt
    }
  }
`

const depositAddedSubscription = graphql`
  subscription walletDepositAddedSubscription {
    depositAdded {
      amount
      currency
      confirmations
      isConfirmed
      confirmationsRequired
      insertedAt
      txid
    }
  }
`

const depositChangedSubscription = graphql`
  subscription walletDepositChangedSubscription {
    depositChanged {
      amount
      currency
      confirmations
      isConfirmed
      confirmationsRequired
      insertedAt
      txid
    }
  }
`

const withdrawAddedSubscription = graphql`
  subscription walletWithdrawAddedSubscription {
    withdrawAdded {
      amount
      currency
      isProcessed
      insertedAt
      txid
      uuid
      meta
    }
  }
`

const withdrawChangedSubscription = graphql`
  subscription walletWithdrawChangedSubscription {
    withdrawChanged {
      amount
      currency
      isProcessed
      insertedAt
      txid
      uuid
      meta
    }
  }
`
